import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../navigation/AuthProvider';

const Dashboard = () => {
  const oAuthContext = useContext(AuthContext);

  return <div className="rightContentWrap"></div>;
};

export default Dashboard;
